import useForm from '@eduzz/houston-forms/deprecated/useForm';
import Form from '@eduzz/houston-ui/Forms/deprecated/Form';
import { Dialog, DialogActions, DialogTitle, Icon, IconButton } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Slide from '@material-ui/core/Slide';
import type { TransitionProps } from '@material-ui/core/transitions';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Alert from 'components/Alert';
import React, { useState } from 'react';
import { useObservable } from 'react-use-observable';
import eduzzAccountsService from 'v2/services/eduzzAccount';

import { Content } from './Content';
import { useStyles } from './styles';

import type { theme as MuiTheme } from 'components/Theme';
import type { FormikHelpers } from 'formik';
import type { Observable } from 'rxjs';

interface IValues {
  email: string;
}

interface IProps {
  onClose: () => void;
  open: boolean;
  onOk: (email: string, callback: () => void) => Observable<any>;
  message?: string;
  reportDescription: string;
  shouldInformUnregisteredEmail?: boolean;
}

const SlideUpTransition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement<any, any> },
  ref: React.Ref<unknown>
) {
  return <Slide direction='up' ref={ref} {...props} />;
});

export const BackgroundExportModal = ({ open, onClose, onOk, reportDescription, shouldInformUnregisteredEmail, message }: IProps) => {
  const classes = useStyles();
  const [success, setSuccess] = useState(false);
  const [sentEmail, setSentEmail] = useState(null);
  const [user] = useObservable(() => eduzzAccountsService.getUser(), []);
  const isMobile = useMediaQuery((theme: typeof MuiTheme) => theme.breakpoints.down('xs'));

  const onSubmit = async (values: IValues, form: FormikHelpers<IValues>) => {
    let confirmation = true;
    if (shouldInformUnregisteredEmail && values.email && user?.email !== values.email) {
      confirmation = await Alert.confirm({
        message: 'Esse e-mail é diferente do e-mail de cadastro, tem certeza que deseja enviar para esse e-mail?',
        title: 'Atenção',
        buttonOk: 'Confirmar',
        confirmation: true,
        size: 'xs',
      });
    }
    if (!confirmation) return;
    const observable = onOk(values.email, () => {
      setSentEmail(values.email);
      setSuccess(true);
      form.setSubmitting(false);
      form.resetForm();
    });
    observable.subscribe();
  };

  const formik = useForm<IValues>({
    onSubmit,
    validationSchema: (yup) =>
      yup.object().shape({
        email: yup.string().email(),
      }),
    initialValues: {
      email: '',
    },
  });

  const handleClose = () => {
    onClose();
    setSuccess(false);
    setSentEmail(null);
    formik.handleReset();
  };

  return (
    <Form context={formik}>
      <Dialog
        maxWidth='sm'
        onClose={handleClose}
        aria-labelledby='background-export-dialog'
        open={open}
        TransitionComponent={SlideUpTransition}
        fullScreen={isMobile}
        fullWidth
      >
        <DialogTitle id='background-export-dialog-title'>
          Exportar relatório de {reportDescription}
          <IconButton id='background-export-close-icon-button' className={classes.closeIcon} size='small' onClick={handleClose}>
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>
        <Content success={success} sentEmail={sentEmail} message={message} />
        <DialogActions className={classes.dialogActions}>
          <Button id='background-export-close-button' variant='text' onClick={handleClose}>
            Fechar
          </Button>
          {!success && (
            <Button
              id='background-export-generate-button'
              variant='contained'
              color='primary'
              disabled={!formik.isValid || formik.isSubmitting}
              startIcon={formik.isSubmitting && <CircularProgress size={20} />}
              type='submit'
              onClick={formik.handleSubmit}
            >
              Gerar
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </Form>
  );
};
